export function captureFormDraft(form, currentDraft = {}) {
  const draft = { ...currentDraft };
  const skippedFields = new Set();

  for (const element of form?.elements || []) {
    if (!(element instanceof HTMLInputElement) || !element.name) {
      continue;
    }
    if (element.type === "checkbox") {
      draft[element.name] = Boolean(element.checked);
      skippedFields.add(element.name);
      continue;
    }
    if (element.type === "file") {
      skippedFields.add(element.name);
    }
  }

  const fields = new FormData(form);
  for (const [name, value] of fields.entries()) {
    if (skippedFields.has(name)) {
      continue;
    }
    draft[name] = String(value);
  }

  return draft;
}
